import React from 'react'
import moment from 'moment'
import 'moment/locale/th'
import { Paper, Typography, Grid, makeStyles } from '@material-ui/core'
import { AgendaListItem } from './Types'
import MyButton from '../../../control/button/button'
import useTranslate from '../../../i18n/useTranslate'

const useStyles = makeStyles((theme) => ({
    card: {
        borderRadius: 10,
        border: '1px solid rgba(0,0,0,0.12)',
        background: '#fff',
        padding: 20,
    },
    actions: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        [theme.breakpoints.down('md')]: { justifyContent: 'flex-end' },
    },
    actionsItem: {
        order: 99,
        [theme.breakpoints.up('lg')]: { order: 0 },
    },
    col: { display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' },
    label: { color: '#6B7280', fontSize: 12, lineHeight: 1.1, marginBottom: 4 },
    value: { fontSize: 14 },
}))

const AgendaCard: React.FC<{
    item: AgendaListItem
    onEdit: (id: number) => void
    onDelete: (id: number) => void
}> = ({ item, onEdit, onDelete }) => {
    const classes = useStyles()
    const t = useTranslate()
    const isTh = t.languageStore.currentLanguage === t.languageKey.th

    function formatDate(
        value: Date | string | number | null | undefined,
        { withTime = false, monthShort = false, buddhistYear = true } = {},
    ): string {
        if (value == null) return '-'
        const m = moment(value)
        if (!m.isValid()) return '-'

        m.locale(isTh ? 'th' : 'en')
        const M = monthShort ? 'MMM' : 'MMMM'

        const base = withTime ? `D ${M} YYYY HH:mm` : `D ${M} YYYY`
        let s = m.format(base)

        if (isTh && buddhistYear) {
            const be = (m.year() + 543).toString()
            s = s.replace(/\d{4}(?!.*\d)/, be)
        }
        return s
    }
    return (
        <Paper elevation={0} className={classes.card}>
            <Grid container spacing={3}>
                <Grid item xs={12} md={12} lg={2} className={classes.actionsItem}>
                    <div className={classes.actions}>
                        <MyButton style={{ minWidth: 60 }} onClick={() => onEdit(item.agendaId)}>
                            {t.get('BUTTON.EDIT')}
                        </MyButton>
                        <MyButton
                            style={{ minWidth: 60 }}
                            variant="contained"
                            color="secondary"
                            onClick={() => onDelete(item.agendaId)}
                        >
                            {t.get('BUTTON.DELETE')}
                        </MyButton>
                    </div>
                </Grid>

                <Grid item xs={12} md={6} lg={2}>
                    <div className={classes.col}>
                        <Typography className={classes.label}> {t.get('UM.SETTING_AGENDA.ROUND')}</Typography>
                        <Typography className={classes.value}>{item.agendaNo || '-'}</Typography>
                    </div>
                </Grid>

                <Grid item xs={12} md={6} lg={4}>
                    <div className={classes.col}>
                        <Typography className={classes.label}> {t.get('UM.SETTING_AGENDA.REPORT_TITLE')}</Typography>
                        <Typography className={classes.value}>{item.agendaName || '-'}</Typography>
                    </div>
                </Grid>

                <Grid item xs={12} md={6} lg={2}>
                    <div className={classes.col}>
                        <Typography className={classes.label}>{t.get('UM.SETTING_AGENDA.CREATED_BY')}</Typography>
                        <Typography className={classes.value}>
                            {isTh ? (item.createdByTh ?? '-') : (item.createdByEn ?? '-')}
                        </Typography>
                    </div>
                </Grid>

                <Grid item xs={12} md={6} lg={2}>
                    <div className={classes.col}>
                        <Typography className={classes.label}>{t.get('UM.SETTING_AGENDA.CREATED_AT')}</Typography>
                        <Typography className={classes.value}>{formatDate(item.createdAt)}</Typography>
                    </div>
                </Grid>
            </Grid>
        </Paper>
    )
}

export default AgendaCard
